<template>
  <RevCardCarousel
    data-qa="card-carousel"
    desktop-card-width="standard"
    :mobile-card-width="mobileCardWidth"
    next-alternative-text="next"
    prev-alternative-text="previous"
  >
    <div
      v-for="(product, index) in products"
      :key="product.title"
      :ref="
        (el) =>
          setTrackingRef(
            product,
            trackingData.provider,
            `${trackingData.list} ${index + 1}`,
            el as HTMLElement,
          )
      "
      class="h-full"
    >
      <ProductCard
        data-test="product-card"
        :description="product.description"
        :image-src="product.image"
        :listing-id="product.listingId"
        :price="product.price"
        :price-new="product.priceNew"
        :review-rating="product.reviewRating"
        :tags="tags"
        :title="product.title"
        :url="`/${product.productPageLink.params.locale}/p/${product.productPageLink.params.slugV2}/${product.productPageLink.params.uuid}`"
        v-on="addToCartListener ? { addToCart: handleAddToCart(product) } : {}"
        @click="
          trackProductClick(
            product,
            trackingData.provider,
            `${trackingData.list} ${index + 1}`,
          )
        "
      />
    </div>
  </RevCardCarousel>
</template>

<script setup lang="ts">
import { getCurrentInstance } from 'vue'

import { RevCardCarousel } from '@ds/components/CardCarousel'

import type { Product, Products } from '~/scopes/core/models/product'

import {
  useClickTracking,
  useImpressionTracking,
} from '../composables/useProductTracking'

import ProductCard from './ProductCard.vue'

const { products, trackingData } = defineProps<{
  products: Products
  trackingData: { provider: 'algolia' | 'attraqt'; list?: string }
  tags?: string[]
}>()

const emits = defineEmits<{
  (e: 'add-to-cart', data: { status: string; product: Product }): void
}>()

const addToCartListener = getCurrentInstance()?.vnode.props?.onAddToCart
const mobileCardWidth = addToCartListener ? 'standard' : 'narrow'

const { setTrackingRef } = useImpressionTracking()
const { trackProductClick } = useClickTracking()

function handleAddToCart(product: Product) {
  return ({ status }: { status: string }) => {
    emits('add-to-cart', { status, product })
  }
}
</script>
